function footerInject(footer_element_node, nodeInfo, placeBefore) {
    // Happens to be the footer element in this case
    var c1 = footer_element_node
    //'dg_footer_item_5'
    // Alter the class name
    var c1v2 = c1 + '-1'
    var e1 = document.getElementsByClassName(c1)
    if (document.getElementsByClassName(c1v2).length > 0) {
        return null
    }
    // newLi(e1[0], '<a itemprop="url" href="/pages/return-policy">Return Policy</a>', c1v2, false)
    newLi(e1[0], nodeInfo, c1v2, placeBefore)
    function newLi(target, nodeInfo, nodeClass, placeBefore) {
        var newNode = document.createElement('li')
        newNode.classList.add(nodeClass)
        newNode.innerHTML = nodeInfo
        target.parentNode.insertBefore(newNode, placeBefore ? target : target.nextSibling)
    }
}